import { insertScript } from '../../../../../../Common/Resources/src_front/js/helper-functions/insertScript';

export const pushengage = () => {
    window._peq = window._peq || [];
    window._peq.push(['init']);

    insertScript('https://clientcdn.pushengage.com/core/75834a2a-5352-4136-be7f-95ce25624b1e.js');
};
